module.exports = __webpack_public_path__ + "/login_ui/img/cg-1d268b0dd5138edac3d946c8717a33ea.svg";